
import React from 'react';

// import { Subclass } from '@dndModels';

// import DandDAPI from '@utilities/smart_api';

import FSIndex from "@dndComponents/FSIndex";
// import LoadingBox from '@components/input/LoadingBox';

// const api = DandDAPI.getInstance();

export default function SubclassIndex() {
  // const [fetched, setFetched] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [loading_message, setLoadingMessage] = useState("");
  // const [percentage, setPercentage] = useState(0);

  // const load = useCallback(async () => {
  //   const subclasses = await api.getObjects<Subclass>({ data_type: "subclass" });
  //   for (let i = 0; i < subclasses.length; ++i) {
  //     const sc = subclasses[i];
  //     setLoadingMessage(sc.name);
  //     await api.loadObject(sc);
  //     setPercentage(i / subclasses.length * 100);
  //   }
  //   setLoading(false);
  // }, []);

  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //     setLoading(true);
  //     setTimeout(() => {
  //       load();
  //     }, 100);
  //   }
  // }, [fetched, load]);

  // if (!fetched || loading) {
  //   return (<LoadingBox message={loading_message} percentage={percentage} />);
  // }

  return (
    <FSIndex
      data_type="subclass"
      quick_fields={["game_class"]}
      // extra_filter={(obj) => {
      //   if (obj instanceof Subclass) {
      //     return obj.feature_bases.some(o => o.level === 1) && obj.feature_bases.some(o => o.level === 2);
      //   }
      //   return false;
      // }}
    />
  );
}
